export const prepareComponentToken = token => {
  const fontSize = token.fontSize,
    lineHeight = token.lineHeight,
    controlHeight = token.controlHeight,
    controlHeightSM = token.controlHeightSM,
    controlHeightLG = token.controlHeightLG,
    paddingXXS = token.paddingXXS,
    controlPaddingHorizontal = token.controlPaddingHorizontal,
    zIndexPopupBase = token.zIndexPopupBase,
    colorText = token.colorText,
    fontWeightStrong = token.fontWeightStrong,
    controlItemBgActive = token.controlItemBgActive,
    controlItemBgHover = token.controlItemBgHover,
    colorBgContainer = token.colorBgContainer,
    colorFillSecondary = token.colorFillSecondary,
    colorBgContainerDisabled = token.colorBgContainerDisabled,
    colorTextDisabled = token.colorTextDisabled;
  const multipleItemHeight = controlHeight - paddingXXS * 2;
  const multipleItemHeightSM = controlHeightSM - paddingXXS * 2;
  const multipleItemHeightLG = controlHeightLG - paddingXXS * 2;
  return {
    zIndexPopup: zIndexPopupBase + 50,
    optionSelectedColor: colorText,
    optionSelectedFontWeight: fontWeightStrong,
    optionSelectedBg: controlItemBgActive,
    optionActiveBg: controlItemBgHover,
    optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
    optionFontSize: fontSize,
    optionLineHeight: lineHeight,
    optionHeight: controlHeight,
    selectorBg: colorBgContainer,
    clearBg: colorBgContainer,
    singleItemHeightLG: controlHeightLG,
    multipleItemBg: colorFillSecondary,
    multipleItemBorderColor: 'transparent',
    multipleItemHeight,
    multipleItemHeightSM,
    multipleItemHeightLG,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: colorTextDisabled,
    multipleItemBorderColorDisabled: 'transparent',
    showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25)
  };
};